import {
  cloneElement, ReactElement, useMemo,
} from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { OptionProps } from 'shared/dnd/Option';

interface DraggableOptionProps {
  id: string | number;
  isDraggable: boolean;
  children: ReactElement<OptionProps>;
}

const DraggableOption = (props:DraggableOptionProps) => {
  const { id, isDraggable = false, children } = props;
  const {
    attributes, listeners, setNodeRef, transform, transition, isDragging,
  } = useSortable({ id });

  const optionProps = useMemo(
    () => (isDraggable
      ? {
        style: {
          transform: CSS.Transform.toString(transform),
          transition,
          opacity: isDragging ? 0.5 : 1,
        },
        ref: setNodeRef,
      }
      : undefined),
    [isDragging, isDraggable, setNodeRef, transform, transition],
  );

  const dragProps = useMemo(
    () => (isDraggable
      ? {
        ...listeners,
        ...attributes,
      }
      : undefined),
    [attributes, isDraggable, listeners],
  );

  if (!children || !isDraggable) {
    return children;
  }

  return cloneElement(children, {
    ...props,
    optionProps,
    dragProps,
  });
};

export default DraggableOption;
